import Basic from '@rebuild/materials/shared/history_nav/BaseHistoryNav.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/history_nav/context';
import { translate } from '@/locales';

function useSelfContext() {
	const formattedNavTitle = nav => {
		if (nav.isHome) return translate('enterprise.hontron-irstore-title');
		return nav.name;
	};

	provideCurrentContext({
		formattedNavTitle
	});
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext)
};
